
import React from 'react'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { ICashCollectionModel } from './CashCollectionModel'


export type CashCollectionRow = {
  id?: string
  createdAt?: Date
  updatedAt?: Date
  transactionDate?: Date

  firstName?: string
  lastName?: string
  receiptNumber?: string
  cashAmount?: number
  cashAmountCurrency?: string
  cashboxRate?: number
  branch?: string
  operator?: string
  description?: string
}

type Props = {
  data: CashCollectionRow[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (row: CashCollectionRow) => void
  onDelete?: (row: CashCollectionRow) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}


const fmtDate = (d?: Date) => (d && !isNaN(d.getTime()) ? d.toLocaleDateString() : '-')
const fmtNumber = (n?: number) => (typeof n === 'number' && !Number.isNaN(n) ? n.toString() : '-')

const CashCollectionTable: React.FC<Props> = (props) => {
  const {
    data, currentPage, totalPages, onPageChange,
    onEdit, onDelete, sortBy, sortOrder, onSort, loading = false
  } = props

  const columns: TableColumn<CashCollectionRow>[] = [
    { key: 'firstName', label: 'Ad', className: 'fw-semibold', sortable: true },
    { key: 'lastName', label: 'Soyad', sortable: true },
    { key: 'transactionDate', label: 'İşlem Tarihi', sortable: true, render: r => fmtDate(r.transactionDate) },
    { key: 'receiptNumber', label: 'Makbuz No', sortable: true },
    { key: 'cashAmount', label: 'Tutar', sortable: true, className: 'text-end', render: r => fmtNumber(r.cashAmount) },
    { key: 'cashAmountCurrency', label: 'Para Birimi', sortable: true },
    { key: 'cashboxRate', label: 'Kur', sortable: true, className: 'text-end', render: r => fmtNumber(r.cashboxRate) },
    { key: 'branch', label: 'İşlem Şube', sortable: true },
    { key: 'operator', label: 'İşlemi Yapan', sortable: true },
    { key: 'createdAt', label: 'Oluşturulma', sortable: true, render: r => fmtDate(r.createdAt) },
    { key: 'description', label: 'Açıklama', sortable: false, render: r => r.description ? (r.description.length > 40 ? r.description.slice(0, 40) + '…' : r.description) : '-' },
  ]

  const actions: TableAction<CashCollectionRow>[] = [
    { label: 'Düzenle', icon: 'bi bi-pencil', className: 'btn-light-primary me-2', onClick: (r) => onEdit?.(r) },
    { label: 'Sil', icon: 'bi bi-trash', className: 'btn-light-danger', onClick: (r) => onDelete?.(r) },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz Tahsilat kaydı bulunamadı'
    />
  )
}


export default CashCollectionTable
